export default __webpack_public_path__ + "static/media/waiting-room.0da79d28.png";